/**
 * Back to top script
 * @returns {jQuery} 
 */
$.fn.smoothScrollTo = function() {
    /**
     * @type {jQuery} - all containers affected by selector
     */
    var jqAllAffectedContainers = this;
   
    jqAllAffectedContainers.each(function() {
       const container = $(this);
       container.on('click', function(e) {
            e.preventDefault();
            const containerToScrollID = container.attr('href');
            if (!containerToScrollID || containerToScrollID == 'undefined') {
                console.warn('smoothScrollTo: href attribute not found in container', container);
                return;
            }
            const containerToScroll = $(containerToScrollID);
             if (!containerToScroll || containerToScroll.length <= 0 || containerToScroll == 'undefined') {
                console.error('smoothScrollTo: containerToScroll not found by id', containerToScrollID);
                return;
            }
            
            $("html, body").animate(
                {scrollTop: containerToScroll.position().top },
                600,
                "linear"
            );
       });
    });

    return jqAllAffectedContainers;
};

document.addEventListener('DOMContentLoaded', function() {
    $('.smooth-scroll-to-js').smoothScrollTo();
});
